import React from 'react';
import type { WorkflowType } from '@this/domain/organization/organization2';

const theme = {
  colors: {
    primary: '#af985e',
    background: '#ffffff',
    text: '#333333',
    border: '#d0d0d0',
    highlight: '#f5f2ea'
  },
  spacing: {
    xs: '8px',
    sm: '16px',
    md: '24px'
  }
};

const getStyles = () => {
  return {
    subSection: {
      position: 'relative' as const,
      marginTop: '16px',
      marginLeft: '16px',
      borderBottom: `1px solid ${theme.colors.border}`,
      paddingBottom: theme.spacing.md,
      marginBottom: theme.spacing.md,
      background: theme.colors.background,
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    } as React.CSSProperties,
    sectionContent: {
      display: 'flex',
      marginTop: '16px',
      gap: '8px',
      flexDirection: 'column' as const,
      background: '#fafafa',
      padding: theme.spacing.sm,
      borderRadius: '6px',
      marginLeft: theme.spacing.sm,
      marginRight: theme.spacing.sm,
      border: `1px solid ${theme.colors.border}`
    } as React.CSSProperties,
    contentLabel: {
      display: 'flex',
      fontWeight: 'bold' as const,
      fontSize: '11px'
    } as React.CSSProperties,
    radioLabel: {
      display: 'flex',
      alignItems: 'center'
    } as React.CSSProperties,
    numberInput: {
      width: '100px',
      marginLeft: '10px',
      padding: '8px',
      border: `1px solid ${theme.colors.border}`,
      borderRadius: '4px',
      boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
      transition: 'border-color 0.2s ease-in-out'
    } as React.CSSProperties,
    titleContainer: {
      position: 'relative' as const,
      width: '100%',
      marginBottom: theme.spacing.sm,
      padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
      background: theme.colors.highlight,
      borderLeft: `4px solid ${theme.colors.primary}`,
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center'
    } as React.CSSProperties,
    titleText: {
      margin: 0,
      fontSize: '14px',
      fontWeight: 'bold' as const,
      color: theme.colors.text
    } as React.CSSProperties
  } as const;
};

const styles = getStyles();

// 基本コンポーネント
export const SubSection: React.FC = ({ children }) => <section style={styles.subSection}>{children}</section>;

export const SubSectionTitle: React.FC = ({ children }) => (
  <div style={styles.titleContainer}>
    <h4 style={styles.titleText}>{children}</h4>
  </div>
);

export const SubSectionContent: React.FC = ({ children }) => <div style={styles.sectionContent}>{children}</div>;

export const ContentLabel: React.FC = ({ children }) => <div style={styles.contentLabel}>{children}</div>;

// 再利用可能な機能コンポーネント
interface WorkflowOptionProps {
  id: string;
  type: WorkflowType;
  selectedType: WorkflowType;
  label: string;
  onChange: () => void;
}

export const WorkflowOption: React.FC<WorkflowOptionProps> = ({ id, type, selectedType, label, onChange }) => (
  <label style={styles.radioLabel} htmlFor={id}>
    <input id={id} type="radio" style={{ marginTop: 0 }} checked={selectedType === type} onChange={onChange} />
    <div>{label}</div>
  </label>
);

interface BufferAmountInputProps {
  amount: number;
  onChange: (value: number) => void;
}

export const BufferAmountInput: React.FC<BufferAmountInputProps> = ({ amount, onChange }) => (
  <div style={{ display: 'flex', marginTop: theme.spacing.xs }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <input
        type="number"
        value={amount}
        onChange={e => {
          const value = parseInt(e.target.value, 10);
          if (!isNaN(value)) {
            onChange(value);
          }
        }}
        style={styles.numberInput}
      />
      <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>円</span>
    </div>
  </div>
);
